import { selectData } from '../../../utils/select-data';
import { requiredHeaders } from '../../../models/required-headers';
import { withJwt } from '../../../utils/with-jwt';
import { mapManagementServiceEnvironment } from '../map-management-service-environment';
import { deviceSnapshotSchema } from '../schemas/device-snapshot.schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Gets all devices in a given period.
 * @param period Current or next period
 * @returns Object containing info on snapshot and devices
 */
export function getSnapshotDevices(this: unknown, period: 1 | 2) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          mapManagementServiceEnvironment.resolve(this).snapshotDevicesUrl
        }?period=${period}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(deviceSnapshotSchema));
}
